import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
const API = window.location.origin + '/api';
const COUNTRIES = ['DE','AT','CH','SK','CZ','PL','HU','GB','FR','IT','NL','BE','ES','PT','SE','NO','DK','FI'];
const Register = () => {
  const [form, setForm] = useState({ company_name: '', email: '', password: '', country: 'DE' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleRegister = async () => {
    setLoading(true); setError('');
    try { await axios.post(`${API}/auth/register`, form); setSuccess(true); }
    catch (err: any) { setError(err.response?.data?.error || 'Registration failed'); }
    finally { setLoading(false); }
  };
  if (success) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"><span className="text-green-600 text-2xl">✓</span></div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Registration received</h2>
        <p className="text-gray-500 text-sm mb-6">Our team will verify your account within 2 business days.</p>
        <Link to="/login" className="text-sm" style={{ color: '#B8860B' }}>Back to login</Link>
      </div>
    </div>
  );
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-black text-2xl" style={{ backgroundColor: '#B8860B' }}>X</div>
          <div><p className="font-bold text-gray-900 text-lg">BULLIONX</p><p className="text-gray-400 text-xs">Register as a dealer</p></div>
        </div>
        {error && <p className="text-red-500 text-xs mb-4 text-center">{error}</p>}
        <div className="space-y-4 mb-6">
          <input type="text" placeholder="Company name" value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none" />
          <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none" />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none" />
          <select value={form.country} onChange={e => setForm({ ...form, country: e.target.value })} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none">
            {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <p className="text-gray-400 text-xs mb-4 text-center">ℹ️ Your account will be reviewed and verified by our team before you can start trading.</p>
        <button onClick={handleRegister} disabled={loading} className="w-full py-3 rounded-lg text-white text-sm font-semibold disabled:opacity-50" style={{ backgroundColor: '#1a1a2e' }}>{loading ? 'Registering...' : 'Register'}</button>
        <p className="text-gray-500 text-sm mt-4 text-center">Already have an account?{' '}<Link to="/login" className="text-blue-500">Login</Link></p>
      </div>
    </div>
  );
};
export default Register;
